(function () {
  'use strict';
  function qs(r, s) { return r.querySelector(s); }
  function qsa(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }

  function initSlider(root) {
    if (root.dataset.mtReady) return;
    root.dataset.mtReady = '1';
    var track = qs(root, '.mt-slider__track');
    if (!track) return;
    var slides = qsa(track, '.mt-slider__slide');
    var prev = qs(root, '[data-mt-prev]');
    var next = qs(root, '[data-mt-next]');
    var dotsWrap = qs(root, '.mt-slider__dots');
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mt-slider__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }
    function slideWidth() {
      return slides[0] ? slides[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : 1;
    }
    function goTo(i) { track.scrollTo({ left: i * slideWidth(), behavior: 'smooth' }); }
    function update() {
      var w = slideWidth();
      var idx = Math.round(track.scrollLeft / w);
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -slideWidth(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: slideWidth(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    var auto = parseFloat(root.dataset.mtAutoplay || '0');
    if (auto > 0) {
      setInterval(function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
      }, auto * 1000);
    }
  }

  function initTabs(root) {
    if (root.dataset.mtReady) return;
    root.dataset.mtReady = '1';
    var btns = qsa(root, '.mt-tabs__btn');
    var panels = qsa(root, '.mt-tabs__panel');
    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b, j) { b.setAttribute('aria-selected', String(i === j)); });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      });
    });
  }

  function initGallery(root) {
    if (root.dataset.mtReady) return;
    root.dataset.mtReady = '1';
    var slides = qsa(root, '[data-mt-gallery-slide]');
    var thumbs = qsa(root, '[data-mt-gallery-thumb]');
    var prev = qs(root, '[data-mt-gallery-prev]');
    var next = qs(root, '[data-mt-gallery-next]');
    var current = 0;
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.hidden = j !== current; });
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', String(j === current)); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    show(0);
  }

  function initIngredients(root) {
    if (root.dataset.mtReady) return;
    root.dataset.mtReady = '1';
    var rows = qsa(root, '[data-mt-ing-row]');
    var details = qsa(root, '[data-mt-ing-detail]');
    rows.forEach(function (row, i) {
      row.addEventListener('click', function () {
        rows.forEach(function (r, j) { r.classList.toggle('is-active', i === j); r.setAttribute('aria-pressed', String(i === j)); });
        details.forEach(function (d, j) { d.hidden = i !== j; });
      });
    });
  }

  function initBundles(root) {
    if (root.dataset.mtReady) return;
    root.dataset.mtReady = '1';
    var form = root.closest('form');
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var bars = qsa(root, '[data-mt-bundle]');
    function select(bar) {
      bars.forEach(function (b) { b.classList.toggle('is-selected', b === bar); });
      var radio = qs(bar, 'input[type="radio"]');
      if (radio) radio.checked = true;
      if (qtyInput && bar.dataset.quantity) qtyInput.value = bar.dataset.quantity;
    }
    bars.forEach(function (bar) { bar.addEventListener('click', function () { select(bar); }); });
    var pre = qs(root, '[data-mt-bundle].is-selected') || bars[0];
    if (pre) select(pre);
  }

  function initTimeline(root) {
    if (root.dataset.mtReady) return;
    root.dataset.mtReady = '1';
    var items = qsa(root, '[data-mt-step]');
    if (!('IntersectionObserver' in window)) { items.forEach(function (i) { i.classList.add('is-active'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('is-active'); });
    }, { rootMargin: '0px 0px -25% 0px' });
    items.forEach(function (i) { io.observe(i); });
  }

  function initAll(scope) {
    var r = scope || document;
    qsa(r, '[data-mt-slider]').forEach(initSlider);
    qsa(r, '[data-mt-tabs]').forEach(initTabs);
    qsa(r, '[data-mt-gallery]').forEach(initGallery);
    qsa(r, '[data-mt-ingredients]').forEach(initIngredients);
    qsa(r, '[data-mt-bundles]').forEach(initBundles);
    qsa(r, '[data-mt-timeline]').forEach(initTimeline);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
